import { NgModule } from '@angular/core';
import { DialogRefreshComponent } from './dialog-refresh.component';
import { SharedModules } from '../../shared.modules';

@NgModule({
    imports: [SharedModules],
    declarations: [DialogRefreshComponent],
    exports: [DialogRefreshComponent]
})
export class DialogRefreshModule { }
